import type { Instruction, InstructionCreate } from '../types'

export const baseFromInstruction = (i: Instruction | null): InstructionCreate => {
  if (!i) {
    return {
      title: '',
      gradient: null,
      cardImage: null,
      timeToRead: 'PT1M',
      content: '',
      titleEn: null,
      contentEn: null,
      titleColor: null,
      coverType: 'type1',
      categoryId: null,
    }
  }
  return {
    title: i.title,
    gradient: i.gradient,
    cardImage: i.cardImage,
    timeToRead: i.timeToRead,
    content: i.content,
    titleEn: i.titleEn,
    contentEn: i.contentEn,
    titleColor: i.titleColor,
    coverType: i.coverType ?? 'type1',
    categoryId: i.categoryId,
  }
}
